module.exports = require('./lib/index')



//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-hot-loader/index.js
// module id = 896
// module chunks = 0